import React from 'react';
import PropTypes from 'prop-types';
import filesize from 'filesize';

import constants from '../../../../qti/Constants';

import styles from './uploadInteraction.scss';

const examContext = constants.componentContexts.EXAM;

const errorTypes = {
    FILE_EXTENSION_NOT_ALLOWED: 'FILE_EXTENSION_NOT_ALLOWED',
    FILE_TOO_LARGE: 'FILE_TOO_LARGE',
    UPLOAD_ERROR: 'UPLOAD_ERROR',
};

class UploadViewError extends React.Component {
    static propTypes = {
        context: PropTypes.string.isRequired,
        error: PropTypes.object.isRequired,
        isCurrent: PropTypes.bool,
        model: PropTypes.object.isRequired,
        services: PropTypes.object.isRequired,
        isReadOnly: PropTypes.bool,
        handleTryAgain: PropTypes.func.isRequired,
    };

    componentDidMount() {
        if (this.props.isCurrent) {
            this.initiallyFocusedElement.focus();
            window.console.log('componentDidRender:UploadViewError');
        }
    }

    componentDidUpdate() {
        if (this.props.isCurrent) {
            this.initiallyFocusedElement.focus();
            window.console.log('componentDidUpdate:UploadViewError');
        }
    }

    render() {
        const { context, error, isReadOnly = false, services } = this.props;
        const { t } = services.translationService;
        const maxFileSize = services.interactionService.getFileUploadMaxSize();
        const maxFileSizeFormatted = filesize(maxFileSize);
        const { supportedFileExtensions } = this.props.model;

        let errorTypeText = '';
        let errorInfoText = '';

        if (error.type === errorTypes.FILE_TOO_LARGE) {
            errorTypeText = t('interactions.upload.error.yourFileIsTooBig');
            errorInfoText = t('interactions.upload.maximumFileSizeText', { maximumFileSize: maxFileSizeFormatted });
        } else if (error.type === errorTypes.FILE_EXTENSION_NOT_ALLOWED) {
            errorTypeText = t('interactions.upload.error.fileExtensionNotAllowed');
            errorInfoText = t('interactions.upload.allowedFileExtensionsText');
            errorInfoText = `${errorInfoText}<br />${supportedFileExtensions}`;
        } else {
            errorTypeText = t('interactions.upload.error.errorWhileUploadingFile');
            errorInfoText = error.text;
        }

        return (
            <div className={styles.fileNotAcceptedView}>
                <div className={styles.errorIcon}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true" />
                </div>

                <div className={styles.contentRowCentered}>
                    <div className={styles.centeredText}>
                        <h3
                            className={styles.errorHeader}
                            tabIndex="-1"
                            ref={(div) => { this.initiallyFocusedElement = div; }}
                        >
                            {t('interactions.upload.errorHeader.weAreSorry')}
                        </h3>
                        <span>{errorTypeText}</span>
                        <div
                            className={styles.fileCriteriaText}
                            dangerouslySetInnerHTML={{ __html: errorInfoText }}
                        />
                    </div>
                </div>

                <div className={styles.contentRowCentered}>
                    <button
                        className={styles.button}
                        onClick={this.props.handleTryAgain}
                        disabled={isReadOnly || context !== examContext}
                    >
                        {t('interactions.upload.btnTryAgain')}
                    </button>
                </div>
            </div>
        );
    }
}

export default UploadViewError;
